import { AbstractFormControl } from "./form-control";

export class CheckboxControl extends AbstractFormControl<HTMLInputElement> {

    getName(): string {
        return this.element.name;
    }

    getValue() {
        return this.element.checked;
    }

    setValue(value: any): void {
        return this.element.checked = value;
    }

    formatValue() {
        return this.getValue() ? 'Yes' : 'No';
    }

    setEnabled(enabled: boolean): void {
        this.element.disabled = !enabled;
    }
}
